module.exports = __webpack_public_path__ + "static/media/IMG_20180306_153459.d94366d0.jpg";